import { Modal } from "antd";
import ChangePassword from "../../ChangePassword";

const ChangePasswordModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      open={true}
      onCancel={onClose}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
    >
      <ChangePassword onClose={onClose} />
    </Modal>
  );
};

export default ChangePasswordModal;
